import React, { PureComponent } from 'react';
import Checkbox from 'components/Checkbox';
import { Filter } from 'model/Filters';
import filters from 'data/filters';

const CSS = require('./TopFilters.less');

const TOP_FILTERS = ['family-friendly', 'instantconfirmation'];

interface TopFilterProps {
  selectedCategories: Filter[];
  onCategoryToggle: (category: any, subcategory: any) => void;
}

class TopFilters extends PureComponent<TopFilterProps> {
  render() {
    return (
      <ul className={CSS.TopFilters}>
        {filters
          .filter(filter => TOP_FILTERS.includes(filter.uid))
          .sort(filter => filter.order)
          .map((filter) => {
            const selectedSubcategories = this.props.selectedCategories.find(selCategory => selCategory.uid === filter.uid);
            const onFilterClick = subcategory => this.props.onCategoryToggle(filter, subcategory);
            return (
              <li key={filter.name} className={CSS.TopFiltersItem}>
                <Checkbox
                  className={CSS.Filter}
                  iconClassName={CSS.FilterIcon}
                  value={filter.name}
                  onChange={onFilterClick}
                  checked={!!selectedSubcategories && selectedSubcategories.value === filter.value}
                >
                  {filter.name}
                </Checkbox>
              </li>
            );
          })
        }
      </ul>
    );
  }
}

export default TopFilters;
